module.exports = __webpack_public_path__ + "static/assets/8e79630077f7786dd18e93eb201cdb58.png";